import { render } from "./BaseColorfulLogo.vue?vue&type=template&id=764b79f0"
const script = {}
script.render = render

export default script